/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateAccountDto
 */
export interface UpdateAccountDto {
    /**
     * Username associated with the account
     * @type {string}
     * @memberof UpdateAccountDto
     */
    userName?: string;
    /**
     * About me section for the account
     * @type {string}
     * @memberof UpdateAccountDto
     */
    aboutMe?: string;
    /**
     * URL of the account avatar
     * @type {string}
     * @memberof UpdateAccountDto
     */
    avatarUrl?: string;
}

/**
 * Check if a given object implements the UpdateAccountDto interface.
 */
export function instanceOfUpdateAccountDto(value: object): value is UpdateAccountDto {
    return true;
}

export function UpdateAccountDtoFromJSON(json: any): UpdateAccountDto {
    return UpdateAccountDtoFromJSONTyped(json, false);
}

export function UpdateAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userName': json['userName'] == null ? undefined : json['userName'],
        'aboutMe': json['aboutMe'] == null ? undefined : json['aboutMe'],
        'avatarUrl': json['avatarUrl'] == null ? undefined : json['avatarUrl'],
    };
}

  export function UpdateAccountDtoToJSON(json: any): UpdateAccountDto {
      return UpdateAccountDtoToJSONTyped(json, false);
  }

  export function UpdateAccountDtoToJSONTyped(value?: UpdateAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userName': value['userName'],
        'aboutMe': value['aboutMe'],
        'avatarUrl': value['avatarUrl'],
    };
}

